module.exports = __webpack_public_path__ + "2d11dc5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/global/Sidebar/static/ic_Kefu_Hover.png
// module id = 944
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 16